(function() {
  'use strict';

  angular
    .module('admin.campaigns.promo.codes.service', [])
    .factory('PromoCodesService', PromoCodesService);

  /** @ngInject */
  function PromoCodesService($http, $q, API) {

    function list(parentId, start, limit, sort){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/promos/' + parentId + '/promo_codes?start=' + start + '&limit=' + limit + '&sort=' + sort)
          .success(defered.resolve);

        return defered.promise;
    }

    function get(parentId, id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/promos/' + parentId + '/promo_codes/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function save(parentId, model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/promos/' + parentId + '/promo_codes', model)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function update(parentId, id, model){
        var defered = $q.defer();

        $http.put(API.API_URL + 'admin/promos/' + parentId + '/promo_codes/' + id, model)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function remove(id){
        var defered = $q.defer();

        $http.delete(API.API_URL + 'admin/promo_codes/' + id)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    return{
       list: list,
       get: get,
       save: save,
       update: update,
       remove: remove,
    };

  }

})();
